export enum FlowTypeEnum {
  CREATE_CASE = 'CREATE_CASE',
  FIND_DOCTOR = 'FIND_DOCTOR',
  ONLINE_CARE = 'ONLINE_CARE'
}
